//*******************************************************
import {  Component, 
          ChangeDetectorRef,
          ViewChild }                     from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Devexpress Components
import {  DxChartComponent }              from 'devextreme-angular';
//*******************************************************
// Field Definitions
import  { 
          whoseguestinit,
          inviteefield,
          inviteedashboard,
          barchartprofile,
          chartdropdowwnlist,
          dashboardinviteelist
        }                                 from '../../appfirestore/app.fields';
//*******************************************************
@Component(
              {
                selector: 'app-cominviteesnapshot',
                templateUrl: './cominviteesnapshot.component.html',
                styleUrls: ['./cominviteesnapshot.component.scss']
              } 
          )
//*******************************************************
export class CominviteesnapshotComponent 
  {
      
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;
    //*******************************************************
    @ViewChild('barinviteechart') BarInviteChart: DxChartComponent;
    //*******************************************************
     // eventinvitee
     subscriptioninvitee: Subscription;
     subscriptioninviteelist: inviteefield[];

    // invitee dashboard
    subscriptiondashboardinvitee: Subscription;
    subscriptiondashboardinviteelist: inviteedashboard[];

    // Event Organisers
    whoseguest: Array<whoseguestinit> = []; // Empty Array
    organiserid: string;

    formData: Array<inviteefield> = [];

    // Chart
    barchart: Array<barchartprofile> = []; // Empty Array

    barchartdropdownlist: Array<chartdropdowwnlist> = []; // Empty Array

    barseriestag: number;

    graphtype: string;

    seriescnt: number = 0;

    chartseriesname: string;     
    charttitle: string = 'Dashboard Other Status';
    chartseriervaluefieldname: string;
    chartseriestag: string;

    seriesname1: string = '';
    seriesname1value: string = '';
    seriesname1tag: string = '';

    seriesname2: string = '';
    seriesname2value: string = '';
    seriesname2tag: string = '';

    seriesname3: string = '';
    seriesname3value: string = '';
    seriesname3tag: string = '';

    selectboxdashother: boolean = false;

     // Address Details
     selunitno:     string = '0';
     selstreetno:   string = '';
     selstreet:     string = '';
     selsuburb:     string = '';
     selpostcode:   string = '';
     selstate:      string = '';
     // Po Box Details
     selpobox:      string = '';
     selposuburb:   string = '';
     selpopostcode: string = '';
     selpostate:    string = '';
     // Contact Details
     selphone:      string = '';
     selmobile:     string = '';
     selemail:      string = '';

     invitationdeliverypoint: string;
     returninviteelist1: string[] = [];
     returninviteelist: Array<dashboardinviteelist> = []; // Empty Array
    //*******************************************************
    constructor (
                  private routernavigate: Router,
                  private firestoredata: firestorecontrol, 
                  private ref: ChangeDetectorRef,
                  private _Activatedroute:ActivatedRoute
                ) 
      { 

       
      }
    //*******************************************************
    ngOnInit(): void 
      {
          // EventId
          this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
          // Form Height
          this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
          //---------------------------------------------------------------------------------------------
          // Event Organiser Initials
          this.firestoredata.buildwhoseguestdetails( this.eventid );
          this.whoseguest = this.firestoredata.geteventparticipantdetails();

          this.whoseguest.push
                                  (
                                    {
                                      id: 'total',
                                      initial: 'Total',
                                      fullname: 'Total'
                                    }
                                  )
          console.log( this.whoseguest )
          //---------------------------------------------------------------------------------------------                         
          // DropDown Box for Chart Selection
          this.barchartdropdownlist.push
                         (
                           {
                             id: 1,
                             chartname: 'Dietary',
                             charttitle: 'Dietary',
                             seriescnt: 1,
                             chartseriesname: 'dietary',
                             chartseriestag:'20',
                             chartseriervaluefieldname: 'dietary' 
                           },   
                 
                           {
                             id:5,
                             chartname: 'Invitation',
                             charttitle: 'Invitation Status',
                             seriescnt: 3,
                             chartseriesname: 'Invited#No-Invite#Yes-Invite',   
                             chartseriestag:'25#30#35',                          
                             chartseriervaluefieldname: 'invitedUndConf#invitationNOTregisted#invitationregisted'
                           },
               
                           {
                             id:10,
                             chartname: 'Seating',
                             charttitle: 'Seating Status',
                             seriescnt: 3,
                             chartseriesname: 'Coming#No-Seating#Yes-Seating',
                             chartseriestag:'40#45#50', 
                             chartseriervaluefieldname: 'coming#tableNOTregistered#tableregistered' 
                           },
               
                           {
                             id:15,
                             chartname: 'Thankyou',
                             charttitle: 'Thankyou Note Status',
                             seriescnt: 3,
                             chartseriesname: 'Invite#No-Gift#Yes-Gift',
                             chartseriestag:'55#60#65', 
                             chartseriervaluefieldname: 'invitedactual#thankyouNOTregisted#thankyouregisted' 
                           }
                 
                         );
  
       // console.log( this.barchartdropdownlist )
  

         

       //   this.buildBarChart( 'sssssss')
      }
    //*******************************************************
    ngOnDestroy() 
      {
          console.log('destroy1')

          if ( this.subscriptiondashboardinvitee !== undefined )
            {
              
              this.subscriptiondashboardinvitee.unsubscribe() 
            }
  
        
      }
    //*******************************************************  
    buildstats( event: any)
      {
        //console.log( event )
        this.selectboxdashother       = true;
        this.organiserid              = event.itemData.id
        this.subscriptioninviteelist  = [];
          
        //console.log(  this.organiserid )
        this.buildBarChart( event.itemData.id, event.itemData.fullname  )

      }
    //---------------------------------------------------------------------------------------------
    // Build Bar Chart
    buildBarChart( seleventorganiserid: string, organisername: string )
      {
          //---------------------------------------------------------------------------------------------
          // Establish Connection to event -> eventparticipant
          this.firestoredata.loadeventdashboardInvitee( this.eventid, seleventorganiserid);

          this.subscriptiondashboardinvitee = this.firestoredata.geteventdashboardorganiser().subscribe
            ( items => 
              { 
                this.subscriptiondashboardinviteelist = items;
               // console.log( this.subscriptiondashboardinviteelist )

                if ( this.subscriptiondashboardinviteelist.length > 0 )
                  {

                   // console.log( this.subscriptiondashboardinviteelist[0].totalcoming )

                    let totalcomingestimate                 = this.subscriptiondashboardinviteelist[0].totalcoming;         // Budget-Estimated Guest to be invited
                  
                    let totalundecided                      = this.subscriptiondashboardinviteelist[0].totalundecided;      // Entered Invitee - undecided
                    let totalconfirm                        = this.subscriptiondashboardinviteelist[0].totalconfirm;        // Entered Invitee - confirm
                    let totalnotcoming                      = this.subscriptiondashboardinviteelist[0].totalnotcoming;      // Entered Invitee - mot coming
                    let totalcomingenter                    = totalundecided + totalconfirm + totalnotcoming;               // Entered in as a Invitee
                    let totalcomingstat1                    = totalundecided + totalconfirm;

                    let dietarycnt                          = this.subscriptiondashboardinviteelist[0].totaldietary;  

                    let totalinvitationregistered           = this.subscriptiondashboardinviteelist[0].totalinvite;
                    let totalinvitationnotregistered        = totalcomingstat1 - totalinvitationregistered;

                    let totaltableregistered                = this.subscriptiondashboardinviteelist[0].totalseat;
                    let totaltablenotregistered             = totalconfirm - totaltableregistered;

                    let totalthankyouregistered             = this.subscriptiondashboardinviteelist[0].totalgiftthankyou;
                    let totalthankyounotregistered          = totalcomingenter - totalthankyouregistered;

                    this.barchart = []; // Empty Array

                    this.barchart.push(   
                                          {
                                            eventparticipant: organisername,
                                            invitedbudget: totalcomingestimate,
                                            invitedactual: totalcomingenter,  
                                            invitedUndConf: totalcomingstat1,
                                            undecided: totalundecided,
                                            coming: totalconfirm,
                                            notcoming:totalnotcoming,
                                            
                                            dietary: dietarycnt,

                                            invitationregisted: totalinvitationregistered,
                                            invitationNOTregisted: totalinvitationnotregistered,

                                            tableregistered: totaltableregistered,
                                            tableNOTregistered: totaltablenotregistered,

                                            thankyouregisted: totalthankyouregistered,
                                            thankyouNOTregisted: totalthankyounotregistered

                                          }
                                      );
                  }
              }
            )
          //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    customizeSeries(valueFromNameField: string) 
      {

       switch ( valueFromNameField ) 
        {
          case 'Invited':
            {
              return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };
            }

          case 'Coming':
            {
              return { type: 'bar', label: { visible: true }, color: '#07046b' };
            }

        }

        return 0
       
      }
    //*******************************************************
    orderLegendItems(items: any) 
      {
        return items.sort((a, b) => {
          let itemA = a.id
          let itemB = b.id
          if(itemA < itemB) return 1;
          if(itemA > itemB) return -1;
          return 0;
                    })
      
      };

    orderLegendOtherItems(items: any) 
      {
        return items.sort((a, b) => {
          let itemA = a.id
          let itemB = b.id
          if(itemA < itemB) return 1;
          if(itemA > itemB) return -1;
          return 0;
                    })
      
      };
  
  //*******************************************************
  onPointClick(event: any) 
    {
      //console.log(event)
      // console.log( event.target.series.name )
      //  console.log( event.target.series.tag )

      //---------------------------------------------------------------------------------------------
      let barseriesname             = event.target.series.name;
      this.barseriestag             = parseInt( event.target.series.tag );
      let orgid                     = this.organiserid; // What is bar is clicked
      //---------------------------------------------------------------------------------------------
      // Reset Invitee details for address, phone, mobile, email
      this.selstreet  = '';
      this.selphone   = '';
      this.selmobile  = '';
      this.selemail   = '';
      //---------------------------------------------------------------------------------------------
     
      this.subscriptioninviteelist  = [];
      //---------------------------------------------------------------------------------------------  

   //   console.log( barseriestag )

      if ( this.barseriestag > 1  )
        {

          switch ( this.barseriestag ) 
            {
              //---------------------------------------------------------------------------------------------
              case 1: // Estimate
                {
                  break
                }

              case 2: // Invited
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'whoseparticipant', orgid );
                  break;
                }

              case 3: // Undecided
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'coming', 0 );
                  break;
                }

              case 4: // Coming
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'coming', 1 );
                  break;
                }

              case 5: // NotComing
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'coming', -1 );
                  break;
                }

              case 20: // Dietary
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'diettype', 'No Dietary Restriction' );
                  break;
                }

              case 25: // All Invitation - Coming = 1 and Undecided = 0 i.e if coming will require a Invite delivery address
                {
                 
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'coming', 0 );
                  break;
                }

              case 30: // Invitation - Not Assign 
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'invitelinkstatus', '0' );
                  break;
                
                }

              case 35: // Invitation - Assign 
                {
                  this.invitationdeliverypoint  = '';
                  this.returninviteelist1       = [];

                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'invitelinkstatus', '1' );
                  break;
                }

              case 40: // Seating - Not Assign & Assign
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'coming', 1 );
                  break;
                }

              case 45: // Seating - Not Assign 
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'table', '0' );
                  break;
                }

              case 50: // Seating - Assign 
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'table', '0' );
                  break;
                }

              case 55: // Thankyou - Not Assign & Assign
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'whoseparticipant', orgid );
                  break;
                }

              case 60: // Thankyou - Not Assign 
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'thankyoulinkid', '0' );
                  break;
                }

              case 65: // Thankyou - Assign 
                {
                  this.firestoredata.loadeventinviteedashboard( this.eventid, this.barseriestag  , orgid, 'thankyoulinkid', '0' );
                  break;
                }

            }
          //---------------------------------------------------------------------------------------------
          this.subscriptioninvitee = this.firestoredata.geteventDashboardinvitee().subscribe
            ( items => 
              { 
                this.subscriptioninviteelist = items;
               // console.log( this.subscriptioninviteelist )
              }
            )
          //---------------------------------------------------------------------------------------------

      }

    }
  //*******************************************************
  onPointHoverChanged(event: any) 
    {
    
      if (event.target !== undefined) 
        {
        //  console.log( event )
          event.target.cursor = 'pointer';
        }
    }
  //*******************************************************
  customizePoint = (arg: any) => 
    {
   
    };
  //*******************************************************  
  xxxx(event: any)
    {
     // console.log( event )
      //---------------------------------------------------------------------------------------------
      this.seriescnt                  = event.itemData.seriescnt;
      this.charttitle                 = event.itemData.charttitle;
      this.chartseriesname            = event.itemData.chartseriesname;
      this.chartseriervaluefieldname  = event.itemData.chartseriervaluefieldname;
      this.chartseriestag             = event.itemData.chartseriestag
      //---------------------------------------------------------------------------------------------
      switch (  this.seriescnt   )
        {
          //---------------------------------------------------------------------------------------------
          case 1: // No of Series 
            {
              this.seriesname1          = this.chartseriesname;
              this.seriesname1value     = this.chartseriervaluefieldname;
              this.seriesname1tag       = this.chartseriestag ;
              break; 
            }
          //---------------------------------------------------------------------------------------------
          case 2: // No of Series 
            {
             
              let seriesnamesplit       = this.chartseriesname.split("#");
              let seriesnamevaluesplit  = this.chartseriervaluefieldname.split("#");
              let seriestagsplit        = this.chartseriestag.split("#");

              this.seriesname1          = seriesnamesplit[0];
              this.seriesname1value     = seriesnamevaluesplit[0];
              this.seriesname1tag       = seriestagsplit[0];

              this.seriesname2          = seriesnamesplit[1];
              this.seriesname2value     = seriesnamevaluesplit[1];
              this.seriesname2tag       = seriestagsplit[1];
              break;
            }
          //---------------------------------------------------------------------------------------------   
          case 3: // No of Series 
            {
             
              let seriesnamesplit      = this.chartseriesname.split("#");
              let seriesnamevaluesplit  = this.chartseriervaluefieldname.split("#");
              let seriestagsplit        = this.chartseriestag.split("#");

              this.seriesname1          = seriesnamesplit[0];
              this.seriesname1value     = seriesnamevaluesplit[0];
              this.seriesname1tag       = seriestagsplit[0];

              this.seriesname2          = seriesnamesplit[1];
              this.seriesname2value     = seriesnamevaluesplit[1];
              this.seriesname2tag       = seriestagsplit[1];

              this.seriesname3          = seriesnamesplit[2];
              this.seriesname3value     = seriesnamevaluesplit[2];
              this.seriesname3tag       = seriestagsplit[2];

              break;
            }
          //---------------------------------------------------------------------------------------------    
          
        }
        //---------------------------------------------------------------------------------------------

      }

      //---------------------------------------------------------------------------------------------
      inviteeclick(event: any )
        {
         
           //console.log( event.data )

          var newinvitee: any;

           this.selstreet   = 'UnitNo: '    + event.data.unitno                                 + '\n' +
                              'StreetNo: '  + event.data.streetno + ' ' + event.data.street     + '\n' +
                              'Suburb: '    + event.data.suburb   + ' ' + event.data.postcode   + '\n' +
                              'State:'      + event.data.state

           this.selphone    = event.data.phone;
           this.selmobile   = event.data.mobile;    
           this.selemail    = event.data.email;
        

           switch ( this.barseriestag )
            {
              //---------------------------------------------------------------------------------------------
              case 35:
                  {
                    let invitelinkid =  event.data.invitelinkid
                  //  console.log( this.barseriestag  + '-' + invitelinkid )

                //  this.returninviteelist = ;

                 //   this.returninviteelist = this.firestoredata.getlistinginvitee(  this.eventid, this.barseriestag, invitelinkid )
                  
                 //   newinvitee             = this.returninviteelist;
                 //   console.log( newinvitee.length )

                  
                  //  console.log( 'No:' + this.returninviteelist.length )

                  //  this.returninviteelist1 = this.returninviteelist[0].inviteename


                  this.firestoredata.getlistinginvitee(  this.eventid, this.barseriestag, invitelinkid ).subscribe
                    ( mapdata =>  { 
                                      
                                      console.log( mapdata)

                                      console.log( mapdata[0].title )

                                      console.log( mapdata[0].inviteename )

                                      this.invitationdeliverypoint  = mapdata[0].title;
                                      this.returninviteelist1       = mapdata[0].inviteename;

                                  }
                    )


                  
                    break;
                  }
              //---------------------------------------------------------------------------------------------

            }

        }
    //*******************************************************  
  }


